import type { MRT_ColumnDef } from "mantine-react-table-open";
import { DownloadTemplateButton } from "../../../../components/SiteTasks/OnboardingWizard/OnboardingAssignment/VollmachtAssignment/Buttons/DownloadTemplateButton";
import { UploadVollmachtPersonMenu } from "../../../../components/SiteTasks/OnboardingWizard/OnboardingAssignment/VollmachtAssignment/Buttons/UploadVollmachtPersonMenu";
import { useVollmachtVermarkterUpload } from "../../../../components/SiteTasks/OnboardingWizard/OnboardingAssignment/VollmachtAssignment/hooks/useVollmachtVermarkterUpload";
import { VollmachtVermarkterConfirmation } from "../../../../components/SiteTasks/OnboardingWizard/OnboardingAssignment/VollmachtAssignment/VollmachtVermarkterConfirmation/VollmachtVermarkterConfirmation";
import type { ExpressOnboardingVollmachtenSite } from "../../ExpressOnboarding.types";

function getExpressOnboardingVollmachtenTableVollmachtenColumn(): MRT_ColumnDef<ExpressOnboardingVollmachtenSite> {
  return {
    id: "vollmacht",
    header: "Vollmachten",
    Cell: ({ row }) => <VollmachtenCell siteId={row.original.site_id} />
  };
}

function VollmachtenCell({ siteId }: { siteId: number }) {
  const {
    confirmationData,
    confirmVollmachtVermarkterMutation,
    generateAndDownloadVollmachtVermarkterMutation,
    personsWithEmAndRedispatch,
    handleCloseConfirmation,
    handleConfirmVollmacht,
    handleFilesSelected
  } = useVollmachtVermarkterUpload(siteId);

  return (
    <>
      <DownloadTemplateButton
        disabled={personsWithEmAndRedispatch.length === 0}
        onClick={() => generateAndDownloadVollmachtVermarkterMutation.mutate()}
      />
      <UploadVollmachtPersonMenu
        disabled={personsWithEmAndRedispatch.length === 0}
        persons={personsWithEmAndRedispatch}
        onFilesSelected={handleFilesSelected}
      />
      {confirmationData && (
        <VollmachtVermarkterConfirmation
          isOpen={true}
          isSubmitting={confirmVollmachtVermarkterMutation.isPending}
          uploadResponse={confirmationData}
          onClose={handleCloseConfirmation}
          onConfirmDataCorrect={() => handleConfirmVollmacht(true)}
          onDiscardFile={() => handleConfirmVollmacht(false)}
        />
      )}
    </>
  );
}

export { getExpressOnboardingVollmachtenTableVollmachtenColumn };
